import {
  MARKETPLACE_PROVISIONED_APPS_FETCH,
  MARKETPLACE_PROVISIONED_APPS_RECEIVE,
  MARKETPLACE_PROVISIONED_APPS_FAILURE,
  MARKETPLACE_PROVISIONED_APPS_TOGGLE_VIEWMORE,
  MARKETPLACE_PROVISIONED_APPS_TOGGLE_HIDDEN_REGION,
  MARKETPLACE_PROVISIONED_APPS_NEXT_PAGE,
  MARKETPLACE_PROVISIONED_APP_DELETE_FAILED,
  MARKETPLACE_PROVISIONED_APP_DELETE_STARTED,
} from "./constant";
import { ProvisionedAppActionTypes } from "../types";
import handleWebsocketData from "../../../hoc/handleWebsocketData";
import handleSortableListActions from "../../../hoc/handleSortableListActions";
import { WebsocketEventNames } from "../../../epics";
import { toggleArrayItem } from "../../../app_shared_functions";
import { ProvisionedAppState } from "../types";

const initialState: ProvisionedAppState = {
  CURRENT_PAGE: 1,
  HIDDEN_REGIONS: [],
  MARKETPLACE_PROVISIONED_APPS_LIST_VIEWMORE: [],
  MARKETPLACE_PROVISIONED_APPS_LIST: [],
};

let marketplace_provisioned_apps = (
  state = initialState,
  action: ProvisionedAppActionTypes,
): ProvisionedAppState => {
  switch (action.type) {
    case MARKETPLACE_PROVISIONED_APPS_FETCH:
      return { ...state };
    case MARKETPLACE_PROVISIONED_APPS_RECEIVE:
      return { ...state, MARKETPLACE_PROVISIONED_APPS_LIST: action.payload };
    case MARKETPLACE_PROVISIONED_APPS_FAILURE:
      return { ...state };
    case MARKETPLACE_PROVISIONED_APPS_TOGGLE_VIEWMORE:
      return {
        ...state,
        MARKETPLACE_PROVISIONED_APPS_LIST_VIEWMORE: action.payload,
      };
    case MARKETPLACE_PROVISIONED_APPS_TOGGLE_HIDDEN_REGION:
      return {
        ...state,
        HIDDEN_REGIONS: toggleArrayItem(state.HIDDEN_REGIONS, action.payload),
      };
    case MARKETPLACE_PROVISIONED_APPS_NEXT_PAGE:
      return { ...state, CURRENT_PAGE: state.CURRENT_PAGE + 1 };
    case MARKETPLACE_PROVISIONED_APP_DELETE_STARTED:
      return { ...state };
    case MARKETPLACE_PROVISIONED_APP_DELETE_FAILED:
      return {
        ...state,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

marketplace_provisioned_apps = handleWebsocketData(
  marketplace_provisioned_apps,
  WebsocketEventNames.MARKETPLACE_PROVISIONED_APPS_LIST,
);
marketplace_provisioned_apps = handleSortableListActions(
  marketplace_provisioned_apps,
  WebsocketEventNames.MARKETPLACE_PROVISIONED_APPS_LIST,
);

export default marketplace_provisioned_apps;
